import {
  ChangeDetectionStrategy,
  Component, EventEmitter,
  Inject,
  Input, OnChanges,
  OnInit,
  Output, SimpleChanges
} from "@angular/core";
import {RouteModel} from "../../../../routes/models/route.model";
import {TaskModel} from "../../../../tasks/models/task.model";
import {routeActionsByStatus} from "../../constants/lean-planning.constant";
import * as _ from "lodash";
import {NgxPermissionsService} from "ngx-permissions";

require('./route-action-menu.scss');
@Component({
  standalone: false,
  selector: 'app-route-action-menu',
  templateUrl: './route-action-menu.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouteActionMenuComponent implements OnInit, OnChanges {
  @Input() route: RouteModel;

  @Output() onAssign = new EventEmitter<null>();
  @Output() onAssignAndSelect = new EventEmitter<null>();
  @Output() onHandleUnpacked = new EventEmitter<null>();
  @Output() onReoptimize = new EventEmitter<null>();
  @Output() onBlock = new EventEmitter<null>();
  @Output() onUnblock = new EventEmitter<null>();
  @Output() onUpdateResource = new EventEmitter<null>();
  @Output() onUpdateBranches = new EventEmitter<null>();
  @Output() onReset = new EventEmitter<null>();
  @Output() onRemove = new EventEmitter<null>();
  @Output() onManageAssistants = new EventEmitter<null>();
  @Output() onChangeRouteColor = new EventEmitter<null>();
  @Output() onUpdateLogisticsVehicle = new EventEmitter<TaskModel>();

  @Output() onPrintIkea = new EventEmitter<null>();
  @Output() onExport = new EventEmitter<null>();
  @Output() onDownloadBillOfLading = new EventEmitter<null>();
  @Output() onPrintBillOfLading = new EventEmitter<null>();
  @Output() onPrintLoadingSheet = new EventEmitter<null>();
  @Output() onPrint = new EventEmitter<null>();

  // public actionsByStatus: any;
  public siteId: any;
  public optimizing: boolean = false;
  public activeActionsMap: any;
  public allowPrintingBillOfLading: boolean;
  public bindingTask: any;


  constructor(@Inject('splitService') private splitService, @Inject('leanPlanningService') private leanPlanningService,
              @Inject(NgxPermissionsService) private permissionsService: NgxPermissionsService) {
  }

  ngOnInit() {
    this.siteId = this.splitService.getSiteId();
    this.allowPrintingBillOfLading = this.splitService.isPrintingBillOfLadingAllowed();
    this.initRouteActions();

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.route && !changes.route.isFirstChange()) {
      this.initRouteActions();
    }
  }

  private initRouteActions() {
    if (!this.route) {
      return;
    }
    this.activeActionsMap = this.leanPlanningService.getRoutesActionsMap([this.route]);

    this._setEditableBoundedEquipment(this.route);
  }

  private _setEditableBoundedEquipment(route) {
    (route.taskListExt || []).forEach((task: TaskModel) => {
      if (task.subTasks && (task.taskSpec.purpose === 'StartRoute' || task.taskSpec.purpose === 'EndRoute')) {

        const bindingSubTask = _.find(task.subTasks, (st) => {
          return _.find(st.actions, (ac) => {
            return ac.type === "VehicleBinding";
          })
        })
        if (!!bindingSubTask) {
          this.bindingTask = task;
        }
      }
    })
  }

}
